import React from 'react';
import { motion } from 'framer-motion';
import { Code, Database, Cloud, GitBranch } from 'lucide-react';
import './Technology.css';

const Technology: React.FC = () => {
  const techStack = [
    {
      category: "AI Models",
      items: ["Commercial LLMs", "Open-source models", "PyTorch", "Hugging Face", "CellPose"],
      icon: <Code className="tech-icon" />
    },
    {
      category: "Development Tools",
      items: ["Claude Code", "GitHub Copilot", "GPT-5", "React", "TypeScript"],
      icon: <GitBranch className="tech-icon" />
    },
    {
      category: "Backend",
      items: ["Flask", "FastAPI", "PostgreSQL", "Redis", "Docker"],
      icon: <Database className="tech-icon" />
    },
    {
      category: "Infrastructure",
      items: ["AWS", "Kubernetes", "CI/CD", "Monitoring", "Auto-scaling"],
      icon: <Cloud className="tech-icon" />
    }
  ];

  return (
    <section id="technology" className="technology">
      <div className="container">
        <motion.div 
          className="tech-header"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Cutting-Edge Technology Stack</h2>
          <p className="section-subtitle">
            Built with modern AI frameworks and scalable cloud infrastructure 
            for fast development and reliable performance.
          </p>
        </motion.div>

        <div className="tech-grid">
          {techStack.map((tech, index) => (
            <motion.div 
              key={index}
              className="tech-card"
              initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="tech-icon-wrapper">
                {tech.icon}
              </div>
              <h3 className="tech-category">{tech.category}</h3>
              <ul className="tech-list">
                {tech.items.map((item, itemIndex) => (
                  <li key={itemIndex} className="tech-item">{item}</li>
                ))}
              </ul>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Technology;